export function redemptionTime(value) {
  if (!value) return 0
  // Legacy CI4 dates are UTC (appTimezone=UTC); new responses include ISO dates.
  return Date.parse(String(value).includes('T') ? value : String(value).replace(' ', 'T') + 'Z') || 0
}
export function redemptionUsable(row, now = Date.now()) {
  return Boolean(row?.qr_token && row.usable !== false && !row.redeemed_at && ['issued', 'sent_to_gt', 'locked'].includes(row.status || 'sent_to_gt') && redemptionTime(row.expires_at_iso || row.expires_at) > now)
}
export function redemptionState(row, now = Date.now()) {
  if (row?.redeemed_at || row?.status === 'redeemed') return 'redeemed'
  if (row?.status === 'cancelled') return 'cancelled'
  if (row?.status === 'expired' || (redemptionTime(row?.expires_at_iso || row?.expires_at) && redemptionTime(row.expires_at_iso || row.expires_at) <= now)) return 'expired'
  if (row?.status && !['issued', 'sent_to_gt', 'locked'].includes(row.status)) return 'unavailable'
  return 'pending'
}
export function stateLabel(row, now = Date.now()) {
  return { pending: 'Por canjear', redeemed: 'Canjeado', expired: 'Vencido', cancelled: 'Cancelado', unavailable: 'No disponible' }[redemptionState(row, now)]
}
export function itemDetails(item) {
  const custom = item.customizations || {}
  const parts = []
  const variant = item.variant || custom.temperatura
  if (variant) parts.push(variant === 'caliente' ? 'Caliente' : 'Frío')
  const milk = item.milk || custom.leche
  if (milk) parts.push(`Leche ${milk}`)
  const ingredients = custom.ingredientes
  if (Array.isArray(ingredients)) parts.push(...ingredients.map(i => typeof i === 'string' ? i : i.name || '').filter(Boolean))
  const notes = item.notes || custom.notas
  if (notes) parts.push(notes)
  return parts.join(' · ')
}
export function formatDate(value) {
  const stamp = redemptionTime(value)
  return stamp ? new Date(stamp).toLocaleString('es-MX', { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' }) : ''
}
